import React from "react";
import "../ReviewSuccessModal.css";

const ReviewSuccessModal = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div className="review-modal-overlay">
      <div className="review-modal">
        <h2> Thank You!</h2>
        <p>Your review has been submitted.</p>
        <p>We appreciate your support! If you haven’t yet, please consider rating us on:</p>

        <div className="review-links">
          <a
            href="https://www.facebook.com/profile.php?id=61583350015395"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="https://res.cloudinary.com/dcuturlmb/image/upload/v1764455630/pngegg1_u8cbug.png" alt="Facebook" />
            Facebook Reviews
          </a>

          {/* <a
            href="https://g.page/r/your-google-review-page"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="https://res.cloudinary.com/dcuturlmb/image/upload/v1764449296/icons8-google-logo-240_clhake.png" alt="Google" />
            Google Reviews
          </a> */}
        </div>

        <button className="review-close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default ReviewSuccessModal;
